// Table layout primitives — port of grid table pattern from
// design/v3/SettingsPage.jsx:307-321 (header row) + :340-364 (body rows) + :442-475.
// 시안의 grid table 은 매 사용처마다 columns 가 달라 단순 wrapper 만 제공한다.
// 사용처: <TableShell><TableHeader columns="...">...</TableHeader><TableRow columns="...">...</TableRow></TableShell>

import type { CSSProperties, ReactNode } from 'react';

export interface TableShellProps {
  children: ReactNode;
  style?: CSSProperties;
}

export function TableShell({ children, style }: TableShellProps) {
  return (
    <div
      style={{
        border: '1px solid var(--border-weak)',
        borderRadius: 10,
        overflowX: 'auto',
        overflowY: 'hidden',
        background: 'var(--bg-surface)',
        maxWidth: '100%',
        minWidth: 0,
        WebkitOverflowScrolling: 'touch',
        ...style,
      }}
    >
      {children}
    </div>
  );
}

export interface TableHeaderProps {
  columns: string;
  gap?: number;
  children: ReactNode;
  style?: CSSProperties;
}

export function TableHeader({ columns, gap = 12, children, style }: TableHeaderProps) {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: columns,
        gap: `var(--table-gap, ${gap}px)`,
        padding: 'var(--table-header-pad)',
        background: 'var(--bg-subtle)',
        fontSize: 11,
        fontWeight: 600,
        color: 'var(--fg-3)',
        textTransform: 'uppercase',
        letterSpacing: 0,
        width: '100%',
        minWidth: 'var(--table-min-width)',
        boxSizing: 'border-box',
        ...style,
      }}
    >
      {children}
    </div>
  );
}

export interface TableRowProps {
  columns: string;
  gap?: number;
  first?: boolean;
  children: ReactNode;
  onClick?: () => void;
  style?: CSSProperties;
}

export function TableRow({
  columns,
  gap = 12,
  first,
  children,
  onClick,
  style,
}: TableRowProps) {
  return (
    <div
      onClick={onClick}
      style={{
        display: 'grid',
        gridTemplateColumns: columns,
        gap: `var(--table-gap, ${gap}px)`,
        padding: 'var(--table-row-pad)',
        alignItems: 'center',
        borderTop: first ? 'none' : '1px solid var(--border-weak)',
        fontSize: 13,
        background: 'var(--bg-surface)',
        cursor: onClick ? 'pointer' : 'default',
        width: '100%',
        minWidth: 'var(--table-min-width)',
        boxSizing: 'border-box',
        ...style,
      }}
    >
      {children}
    </div>
  );
}
